module.exports = __webpack_public_path__ + "static/img/bannerTxt2.6684428d.png";